'use client';

import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import HeroSlider from '@/components/HeroSlider';

interface NavItem {
  label: string;
  href: string;
  children?: {label: string;href: string;}[];
}

interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  slug?: string | null;
}

interface ValueItem {
  icon: string;
  title: string;
  description: string;
}

interface TestimonialItem {
  quote: string;
  author: string;
  role: string;
  satisfaction: number;
}

interface BlogPost {
  image: string;
  alt: string;
  tag: string;
  title: string;
}

interface SpecialtyItem {
  image: string;
  alt: string;
  title: string;
  description: string;
}

interface FaqItem {
  question: string;
  answer: string;
}

interface StatItem {
  value: number;
  suffix: string;
  label: string;
}

const navItems: NavItem[] = [
{ label: 'Accueil', href: '#accueil' },
{
  label: 'A Propos',
  href: '#apropos',
  children: [
  { label: 'Notre Histoire', href: '#histoire' },
  { label: 'Mission & Vision', href: '#mission' },
  { label: 'Nos Valeurs', href: '#valeurs' }]

},
{
  label: 'Services',
  href: '#services',
  children: [
  { label: 'Medecine Generale', href: '/services/medecine-generale' },
  { label: 'Medecine Specialisee', href: '/services/medecine-specialisee' },
  { label: 'Telemedecine', href: '/services/telemedecine' },
  { label: 'Analyses Biomedicales', href: '/services/analyses-biomedicales' },
  { label: 'Evacuation Sanitaire', href: '/services/evacuation-sanitaire' },
  { label: 'Soins Preventifs', href: '/services/soins-preventifs' }]

},
{
  label: 'Notre Franchise',
  href: '#franchise',
  children: [
  { label: 'Modele de Franchise', href: '#franchise' },
  { label: 'Devenir Franchise', href: '#franchise' }]

},
{ label: 'Partenaires', href: '#partenaires' },
{ label: 'Contact', href: '/contact' }];


const services: ServiceItem[] = [
{ icon: 'fa-solid fa-stethoscope', title: 'Medecine Generale', description: 'Consultations, diagnostics, suivi medical et bilans annuels. Repond a 80% des demandes de consultation.', slug: 'medecine-generale' },
{ icon: 'fa-solid fa-heart-pulse', title: 'Medecine Specialisee', description: 'Pediatrie, Gynecologie, Cardiologie, Ophtalmologie, ORL, Dermatologie et bien plus encore.', slug: 'medecine-specialisee' },
{ icon: 'fa-solid fa-laptop-medical', title: 'Telemedecine', description: 'Diagnostics a distance grace a des outils specialises et l expertise de professionnels qualifies.', slug: 'telemedecine' },
{ icon: 'fa-solid fa-flask', title: 'Analyses Biomedicales', description: 'En partenariat avec le Labo Dr. Pierre MONTAGNIER, analyses de haute precision et collecte d echantillons.', slug: 'analyses-biomedicales' },
{ icon: 'fa-solid fa-house-medical', title: 'Medecine de Proximite', description: 'Realisation de diagnostics directement au domicile des patients, sur demande.', slug: null },
{ icon: 'fa-solid fa-truck-medical', title: 'Evacuation Sanitaire', description: 'Partenariat avec les autorites locales pour accompagner les patients vers des centres specialises.', slug: 'evacuation-sanitaire' },
{ icon: 'fa-solid fa-shield-heart', title: 'Soins Preventifs', description: 'Dietetique, kinesitherapie, vaccinations, programmes de prevention et conseil medical.', slug: 'soins-preventifs' },
{ icon: 'fa-solid fa-spa', title: 'Bien-etre & Confort', description: 'Espace ludique pour enfants et salle de relaxation pour adultes dans un cadre apaisant.', slug: null }];


const values: ValueItem[] = [
{ icon: 'fa-solid fa-award', title: 'Excellence', description: 'Maintenir des standards eleves conformes aux meilleures pratiques internationales.' },
{ icon: 'fa-solid fa-lightbulb', title: 'Innovation', description: 'Integrer les dernieres technologies medicales, dont la telemedecine et la radiologie mobile.' },
{ icon: 'fa-solid fa-users', title: 'Accessibilite', description: 'Assurer des soins accessibles a une large population, incluant la classe moyenne et les entreprises.' },
{ icon: 'fa-solid fa-star', title: 'Esthetisme', description: 'Creer un environnement accueillant, moderne et agreable pour les patients.' },
{ icon: 'fa-solid fa-graduation-cap', title: 'Formation Continue', description: 'Former continuellement le personnel pour maintenir un haut niveau de competence.' },
{ icon: 'fa-solid fa-hand-holding-heart', title: 'Responsabilite Sociale', description: 'Etre un acteur majeur aupres des enfants en difficultes sanitaires et des ONG.' }];


const stats: StatItem[] = [
{ value: 70, suffix: '+', label: 'Ans d expertise medicale' },
{ value: 8, suffix: '', label: 'Specialites medicales' },
{ value: 100, suffix: '%', label: 'Engagement qualite' },
{ value: 1, suffix: '', label: 'Reseau panafricain' }];


const testimonials: TestimonialItem[] = [
{ quote: 'COSA m a offert des soins d une qualite exceptionnelle dans un cadre moderne et rassurant. Le personnel est attentionne et tres professionnel.', author: 'Aminata Kone', role: 'Patiente, Abidjan', satisfaction: 98 },
{ quote: 'Le personnel est attentionne et professionnel. Je recommande vivement COSA a toute ma famille et mes collegues. Une clinique de reference en Cote d Ivoire.', author: 'Kouame Brou', role: 'Employe, Groupe Cofina', satisfaction: 96 },
{ quote: 'Enfin une clinique moderne a la hauteur de mes attentes en Cote d Ivoire. Les equipements sont de pointe et les medecins tres competents.', author: 'Fatou Diallo', role: 'Entreprise partenaire', satisfaction: 97 },
{ quote: 'La telemedecine proposee par COSA m a permis de consulter un specialiste depuis mon domicile. Une innovation remarquable pour l Afrique.', author: 'Sekou Traore', role: 'Patient, Abidjan', satisfaction: 95 },
{ quote: 'Le suivi medical de mes employes par COSA est exemplaire. Les bilans annuels sont complets et les resultats sont communiques rapidement.', author: 'Mariam Ouedraogo', role: 'DRH, Entreprise partenaire', satisfaction: 99 }];


const blogPosts: BlogPost[] = [
{ image: "https://img.rocket.new/generatedImages/rocket_gen_img_19153d869-1784560619885.png", alt: 'Medecin africain expliquant l importance des bilans de sante annuels a un patient dans une clinique moderne', tag: 'Prevention', title: 'L importance des bilans de sante annuels en Afrique' },
{ image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e1655f-1772499294308.png", alt: 'Medecin africain utilisant une tablette pour une consultation de telemedecine a distance', tag: 'Telemedecine', title: 'La telemedecine : revolutionner l acces aux soins en Cote d Ivoire' },
{ image: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=600&q=80', alt: 'Centre medical COSA moderne avec personnel medical africain souriant en blouse blanche', tag: 'Franchise', title: 'COSA : un modele de franchise medicale au service de l Afrique' }];


const specialties: SpecialtyItem[] = [
{ image: "https://img.rocket.new/generatedImages/rocket_gen_img_12bc7169c-1773142299522.png", alt: 'Pediatre africain examinant un enfant avec ses parents presents dans une salle de consultation', title: 'Pediatrie', description: 'Soins specialises pour les enfants avec un environnement ludique et rassurant.' },
{ image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b22a1c3f-1769177313985.png", alt: 'Gynecologue africaine en consultation avec une patiente dans une salle moderne et equipee', title: 'Gynecologie & Obstetrique', description: 'Suivi complet de la sante feminine et de la maternite.' },
{ image: "https://img.rocket.new/generatedImages/rocket_gen_img_198d5ece6-1773048727491.png", alt: 'Technicien de laboratoire africain analysant des echantillons biologiques avec equipements modernes', title: 'Analyses Biomedicales', description: 'Laboratoire de haute precision en partenariat avec le Labo Dr. Pierre MONTAGNIER.' }];


const faqs: FaqItem[] = [
{ question: 'Q1. Comment prendre rendez-vous chez COSA ?', answer: 'Vous pouvez prendre rendez-vous par telephone, via notre formulaire en ligne ou directement en vous presentant a notre centre COSA Ananeraie a Abidjan. Notre equipe d accueil est disponible du lundi au vendredi de 8h a 18h et le samedi de 8h a 14h.' },
{ question: 'Q2. Quelles specialites medicales sont disponibles a COSA ?', answer: 'COSA propose 8 specialites medicales : Medecine generale, Pediatrie, Gynecologie, Radiologie, Diabetologie, Ophtalmologie, Fibroscopie et ORL. Nous proposons egalement la telemedecine et les analyses biomedicales.' },
{ question: 'Q3. COSA prend-il en charge les assurances medicales ?', answer: 'Oui, COSA travaille en partenariat avec de nombreuses compagnies d assurances dont YAKO AFRICA ASSURANCES VIE, AMSA Assurances, SUNU Assurances, AXA, NSIA et COMAR ASSURANCES. Contactez-nous pour verifier votre couverture.' },
{ question: 'Q4. Comment fonctionne le service de telemedecine ?', answer: 'Notre service de telemedecine utilise une valise de telemedecine specialisee permettant des diagnostics a distance. Vous pouvez consulter un medecin qualifie depuis votre domicile ou votre lieu de travail via notre plateforme securisee.' }];


const partners = [
'Cofina', 'FIN Elle', 'Ferili', 'LOGILIS', 'Cofina Academy',
'JALO', 'Neemba CAT', 'YAKO AFRICA', 'Nestle', 'SOCIPACK',
'CIE', 'SODECI', 'ASCOMA', 'AMSA Assurances', 'SUNU Assurances',
'AXA', 'CI-ENERGIES', 'NSIA', 'Novelia', 'COMAR ASSURANCES'];


function useCounter(target: number, duration: number, start: boolean) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime: number | null = null;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) {setInView(true);observer.disconnect();}},
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return { ref, inView };
}

function StatCounter({ value, suffix, label }: StatItem) {
  const { ref, inView } = useInView(0.3);
  const count = useCounter(value, 2000, inView);
  return (
    <div ref={ref} style={{ textAlign: 'center' }}>
      <h2 style={{ fontSize: 42, fontWeight: 800, color: '#fbaf45', margin: 0 }}>
        {count}{suffix}
      </h2>
      <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)', margin: '6px 0 0', fontWeight: 500 }}>{label}</p>
    </div>);

}

function AnimatedSection({ children, className = '', delay = 0 }: {children: React.ReactNode;className?: string;delay?: number;}) {
  const { ref, inView } = useInView(0.1);
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`
      }}>
      
      {children}
    </div>);

}

function CosaLogo({ dark = false }: {dark?: boolean;}) {
  return (
    <img
      src={dark ? '/assets/images/logo-cosa.png' : '/assets/images/logo-cosa-dark.png'}
      alt="COSA – Compagnie de Santé Africaine"
      style={{
        height: dark ? 56 : 64,
        width: 'auto',
        maxWidth: 200,
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}

export default function COSAPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [formData, setFormData] = useState({ nom: '', prenom: '', telephone: '', email: '', service: '', date: '', message: '' });

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleFormSubmit = (e: React.FormEvent) => {e.preventDefault();};

  const css = `
    :root { --primary: #0e5932; --accent: #fbaf45; --bg: #F0F7F3; --text: #7D7D75; --white: #FFFFFF; --dark: #1a1a1a; }
    * { box-sizing: border-box; }
    html { scroll-behavior: smooth; }
    .cosa-page { font-family: 'Onest', sans-serif; background: var(--bg); color: var(--text); }
    .cosa-page a { text-decoration: none; }
    .cosa-page p { line-height: 1.6em; margin-bottom: 0; }
    .cosa-page h1,.cosa-page h2,.cosa-page h3,.cosa-page h4 { font-weight: 700; line-height: 1.2em; margin: 0; }
    .cosa-page ul { list-style: none; padding: 0; margin: 0; }
    .cosa-page figure { margin: 0; }
    .cosa-page img { max-width: 100%; display: block; }
    .cosa-page input,.cosa-page textarea,.cosa-page select { font-family: 'Onest', sans-serif; }
    .cosa-page button { font-family: 'Onest', sans-serif; }
    .cosa-container { max-width: 1300px; margin: 0 auto; padding: 0 15px; }
    .cosa-topbar { background: var(--accent); padding: 10px 0; }
    .cosa-header { background: white; box-shadow: 0 2px 20px rgba(0,0,0,0.08); }
    .cosa-header.sticky { position: fixed; top: 0; left: 0; right: 0; z-index: 999; animation: slideDown 0.3s ease; }
    @keyframes slideDown { from { transform: translateY(-100%); } to { transform: translateY(0); } }
    .cosa-nav { display: flex; justify-content: space-between; align-items: center; height: 80px; }
    .cosa-nav-links { display: flex; align-items: center; gap: 4px; }
    .cosa-nav-item { position: relative; }
    .cosa-nav-link { font-size: 15px; font-weight: 500; color: var(--dark); padding: 8px 14px; transition: color 0.3s; cursor: pointer; display: flex; align-items: center; gap: 4px; white-space: nowrap; }
    .cosa-nav-link:hover { color: var(--primary); }
    .cosa-dropdown { position: absolute; top: calc(100% + 8px); left: 0; background: white; border-radius: 12px; box-shadow: 0 12px 40px rgba(0,0,0,0.12); min-width: 220px; padding: 8px; z-index: 1000; border: 1px solid rgba(14,89,50,0.08); }
    .cosa-dropdown a { display: block; padding: 10px 16px; font-size: 14px; font-weight: 500; color: var(--dark); border-radius: 8px; transition: all 0.2s; }
    .cosa-dropdown a:hover { background: rgba(14,89,50,0.06); color: var(--primary); }
    .btn-cosa { position: relative; display: inline-block; font-size: 16px; font-weight: 600; line-height: 1em; background: var(--accent); color: white; border-radius: 100px; padding: 17px 30px; margin-right: 36px; border: none; transition: 0.4s ease-in-out; z-index: 1; overflow: visible; cursor: pointer; }
    .btn-cosa::before { content: ''; position: absolute; top: 50%; right: -36px; width: 50px; height: 50px; border-radius: 50%; background-color: var(--accent); background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12h14M13 6l6 6-6 6'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: center; background-size: 22px; border: 2px solid var(--bg); transform: translateY(-50%); transition: 0.4s ease-in-out; }
    .btn-cosa:hover::before { background-color: var(--primary); transform: translateY(-50%) rotate(45deg); }
    .btn-cosa::after { content: ''; position: absolute; inset: 0 50%; width: 0; height: 100%; border-radius: 100px; opacity: 0; background: var(--primary); transition: 0.4s ease-in-out; z-index: -1; }
    .btn-cosa:hover::after { width: 100%; left: 0; right: 0; opacity: 1; }
    .btn-cosa:hover { color: white; }
    .btn-cosa.sm { font-size: 14px; padding: 13px 22px; }
    .section-badge { display: inline-flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.1em; color: var(--primary); background: rgba(14,89,50,0.1); border-radius: 100px; padding: 7px 16px; margin-bottom: 14px; }
    .section-badge.white { color: white; background: rgba(255,255,255,0.15); }
    .section-badge.gold { color: white; background: rgba(251,175,69,0.2); border: 1px solid rgba(251,175,69,0.4); }
    .section-h2 { font-size: clamp(26px, 3.5vw, 46px); font-weight: 700; line-height: 1.15em; color: var(--dark); margin-bottom: 14px; }
    .section-h2.white { color: white; }
    .section-p { font-size: 16px; line-height: 1.7em; color: var(--text); max-width: 600px; }
    .section-p.white { color: rgba(255,255,255,0.75); }
    .bg-white-card { max-width: 1820px; background: white; border-radius: 14px; margin: 0 auto; }
    .image-anime { position: relative; overflow: hidden; border-radius: 12px; }
    .image-anime::after { content: ''; position: absolute; width: 200%; height: 0%; left: 50%; top: 50%; background-color: rgba(255,255,255,0.3); transform: translate(-50%,-50%) rotate(-45deg); z-index: 1; transition: 600ms linear; }
    .image-anime:hover::after { height: 250%; background-color: transparent; }
    .image-anime img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.6s ease; }
    .image-anime:hover img { transform: scale(1.05); }
    .parallax-bg { background-attachment: fixed; background-size: cover; background-position: center; background-repeat: no-repeat; }
    .service-item { display: flex; align-items: flex-start; gap: 20px; padding: 22px; border-radius: 12px; border: 1px solid rgba(14,89,50,0.1); background: white; transition: all 0.4s ease; margin-bottom: 14px; }
    .service-item:hover { border-color: var(--accent); box-shadow: 0 8px 30px rgba(14,89,50,0.12); transform: translateY(-2px); }
    .icon-box-sm { width: 54px; height: 54px; border-radius: 12px; background: rgba(14,89,50,0.08); display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all 0.4s ease; }
    .service-item:hover .icon-box-sm { background: var(--accent); }
    .service-item:hover .icon-box-sm i { color: white !important; }
    .value-card { padding: 30px 22px; border-radius: 14px; background: white; border: 1px solid rgba(14,89,50,0.08); transition: all 0.4s ease; height: 100%; }
    .value-card:hover { border-color: var(--accent); box-shadow: 0 12px 40px rgba(14,89,50,0.12); transform: translateY(-4px); }
    .icon-box-lg { width: 62px; height: 62px; border-radius: 14px; background: rgba(14,89,50,0.08); display: flex; align-items: center; justify-content: center; margin-bottom: 18px; transition: all 0.4s ease; }
    .value-card:hover .icon-box-lg { background: var(--primary); }
    .value-card:hover .icon-box-lg i { color: white !important; }
    .case-item { border-radius: 14px; overflow: hidden; position: relative; transition: all 0.4s ease; }
    .case-item:hover { transform: translateY(-6px); box-shadow: 0 16px 50px rgba(14,89,50,0.2); }
    .case-item-img { height: 280px; overflow: hidden; }
    .case-item-img img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.6s ease; }
    .case-item:hover .case-item-img img { transform: scale(1.08); }
    .case-item-overlay { position: absolute; bottom: 0; left: 0; right: 0; padding: 22px; background: linear-gradient(to top, rgba(14,89,50,0.95), transparent); }
    .case-item-tag { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: var(--accent); background: rgba(251,175,69,0.15); padding: 3px 10px; border-radius: 100px; display: inline-block; margin-bottom: 8px; }
    .case-item-title { font-size: 17px; font-weight: 700; color: white; line-height: 1.3em; }
    .special-item { display: flex; align-items: center; gap: 18px; padding: 18px; border-radius: 12px; border: 1px solid rgba(14,89,50,0.1); background: white; margin-bottom: 14px; transition: all 0.4s ease; }
    .special-item:hover { border-color: var(--accent); box-shadow: 0 8px 30px rgba(14,89,50,0.1); transform: translateX(4px); }
    .special-item-img { width: 78px; height: 78px; border-radius: 10px; overflow: hidden; flex-shrink: 0; }
    .special-item-img img { width: 100%; height: 100%; object-fit: cover; }
    .testimonial-card { background: white; border-radius: 16px; padding: 30px; border: 1px solid rgba(14,89,50,0.08); display: flex; flex-direction: column; gap: 22px; transition: all 0.4s ease; }
    .testimonial-card:hover { box-shadow: 0 12px 40px rgba(14,89,50,0.1); transform: translateY(-3px); }
    .accordion-item { border: 1px solid rgba(14,89,50,0.1); border-radius: 12px; margin-bottom: 10px; overflow: hidden; transition: all 0.3s ease; }
    .accordion-item.open { border-color: var(--accent); box-shadow: 0 4px 20px rgba(251,175,69,0.15); }
    .accordion-btn { width: 100%; padding: 18px 22px; background: white; border: none; text-align: left; font-size: 15px; font-weight: 600; color: var(--dark); cursor: pointer; display: flex; justify-content: space-between; align-items: center; transition: all 0.3s ease; font-family: 'Onest', sans-serif; }
    .accordion-btn:hover,.accordion-btn.open { color: var(--primary); }
    .accordion-body { padding: 0 22px 18px; font-size: 15px; line-height: 1.7em; color: var(--text); }
    .post-card { border-radius: 14px; overflow: hidden; background: white; border: 1px solid rgba(14,89,50,0.08); transition: all 0.4s ease; }
    .post-card:hover { box-shadow: 0 12px 40px rgba(14,89,50,0.12); transform: translateY(-4px); }
    .post-img { position: relative; height: 220px; overflow: hidden; }
    .post-img img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.6s ease; }
    .post-card:hover .post-img img { transform: scale(1.08); }
    .post-tag { position: absolute; bottom: 12px; left: 12px; background: var(--accent); color: white; font-size: 11px; font-weight: 700; padding: 4px 12px; border-radius: 100px; text-transform: uppercase; letter-spacing: 0.05em; }
    .post-body { padding: 22px; }
    .post-title { font-size: 17px; font-weight: 700; color: var(--dark); line-height: 1.4em; margin-bottom: 14px; transition: color 0.3s; }
    .post-card:hover .post-title { color: var(--primary); }
    .readmore { position: relative; display: inline-block; font-weight: 600; font-size: 14px; color: var(--dark); padding-right: 26px; transition: all 0.3s ease; }
    .readmore::before { content: ''; position: absolute; top: 50%; right: 0; width: 18px; height: 18px; background-color: var(--accent); border-radius: 50%; transform: translateY(-50%); background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12h14M13 6l6 6-6 6'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: center; background-size: 11px; transition: 0.4s ease-in-out; }
    .readmore:hover { color: var(--accent); }
    .readmore:hover::before { transform: translateY(-50%) rotate(45deg); }
    .form-field { width: 100%; padding: 13px 16px; border: 1px solid rgba(14,89,50,0.15); border-radius: 10px; font-size: 15px; color: var(--dark); background: white; outline: none; transition: border-color 0.3s; font-family: 'Onest', sans-serif; }
    .form-field:focus { border-color: var(--primary); box-shadow: 0 0 0 3px rgba(14,89,50,0.08); }
    .form-field::placeholder { color: #aaa; }
    .form-label { display: block; font-size: 13px; font-weight: 600; color: var(--dark); margin-bottom: 5px; }
    .partner-pill { display: inline-flex; align-items: center; padding: 9px 18px; background: white; border: 1px solid rgba(14,89,50,0.1); border-radius: 100px; font-size: 13px; font-weight: 600; color: var(--dark); transition: all 0.3s ease; white-space: nowrap; }
    .partner-pill:hover { border-color: var(--accent); color: var(--primary); box-shadow: 0 4px 16px rgba(14,89,50,0.1); }
    .footer-link { color: rgba(255,255,255,0.65); font-size: 14px; transition: color 0.3s; display: flex; align-items: center; gap: 8px; }
    .footer-link:hover { color: var(--accent); }
    .social-btn { width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.1); display: flex; align-items: center; justify-content: center; color: white; font-size: 14px; transition: all 0.3s; border: 1px solid rgba(255,255,255,0.15); }
    .social-btn:hover { background: var(--accent); border-color: var(--accent); }
    .mobile-menu { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: white; z-index: 9999; padding: 24px; overflow-y: auto; transform: translateX(-100%); transition: transform 0.4s ease; }
    .mobile-menu.open { transform: translateX(0); }
    .mobile-link { display: block; padding: 15px 0; font-size: 17px; font-weight: 600; color: var(--dark); border-bottom: 1px solid rgba(14,89,50,0.08); transition: color 0.3s; }
    .mobile-link:hover { color: var(--primary); }
    .swiper-dots { display: flex; justify-content: center; gap: 8px; margin-top: 24px; }
    .swiper-dot { width: 10px; height: 10px; border-radius: 50%; background: rgba(14,89,50,0.2); cursor: pointer; transition: all 0.3s ease; border: none; }
    .swiper-dot.active { background: var(--accent); width: 28px; border-radius: 5px; }
    .footer-nl-input { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15); border-radius: 100px; padding: 12px 50px 12px 18px; color: white; font-size: 14px; width: 100%; outline: none; font-family: 'Onest', sans-serif; }
    .footer-nl-input::placeholder { color: rgba(255,255,255,0.5); }
    .footer-nl-input:focus { border-color: var(--accent); }
    .timeline-item { display: flex; gap: 22px; padding-bottom: 30px; position: relative; }
    .timeline-item::before { content: ''; position: absolute; left: 18px; top: 40px; bottom: 0; width: 2px; background: rgba(14,89,50,0.15); }
    .timeline-item:last-child::before { display: none; }
    .timeline-dot { width: 38px; height: 38px; border-radius: 50%; background: var(--primary); border: 3px solid var(--accent); flex-shrink: 0; display: flex; align-items: center; justify-content: center; color: white; font-size: 11px; font-weight: 700; z-index: 1; }
    .franchise-step { display: flex; gap: 18px; padding: 18px 0; border-bottom: 1px solid rgba(14,89,50,0.08); }
    .franchise-step:last-child { border-bottom: none; }
    .franchise-num { width: 38px; height: 38px; border-radius: 50%; background: var(--accent); color: white; font-weight: 700; font-size: 15px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .counter-box { background: var(--primary); border-radius: 14px; padding: 22px; text-align: center; }
    .appt-hours { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15); border-radius: 14px; padding: 22px; margin-top: 22px; }
    .appt-hours li { display: flex; justify-content: space-between; padding: 9px 0; border-bottom: 1px solid rgba(255,255,255,0.1); font-size: 14px; color: rgba(255,255,255,0.85); }
    .appt-hours li:last-child { border-bottom: none; }
    .appt-hours li span { font-weight: 600; color: var(--accent); }
    .faq-cta { background: var(--primary); border-radius: 14px; padding: 26px; margin-top: 22px; }
    .faq-cta li a { display: flex; align-items: center; gap: 10px; color: white; font-size: 14px; font-weight: 500; padding: 7px 0; transition: color 0.3s; }
    .faq-cta li a:hover { color: var(--accent); }
    .footer-text-bar { display: flex; align-items: center; gap: 22px; padding: 18px 26px; background: rgba(14,89,50,0.05); border-radius: 12px; border: 1px solid rgba(14,89,50,0.1); margin-top: 38px; flex-wrap: wrap; }
    .footer-text-bar p { font-size: 14px; color: #555; margin: 0; }
    .footer-text-bar p span { background: var(--accent); color: white; font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 100px; margin-right: 8px; text-transform: uppercase; }
    .footer-text-bar a { color: var(--primary); font-weight: 600; }
    .border-list { display: flex; gap: 16px; flex-wrap: wrap; }
    .border-list li { font-size: 13px; font-weight: 600; color: #555; padding: 5px 14px; border: 1px solid rgba(14,89,50,0.15); border-radius: 100px; }
    .border-list li i { color: var(--accent); margin-right: 2px; }
    .why-list ul { list-style: none; display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
    .why-list li { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 500; color: var(--dark); }
    .why-list li::before { content: ''; width: 7px; height: 7px; border-radius: 50%; background: var(--accent); flex-shrink: 0; }
    .why-quote { background: rgba(14,89,50,0.06); border-left: 4px solid var(--accent); border-radius: 0 10px 10px 0; padding: 18px 22px; font-size: 15px; font-style: italic; color: var(--dark); line-height: 1.7em; margin: 18px 0; }
    .contact-pill { display: flex; align-items: center; gap: 14px; padding: 14px 18px; background: rgba(14,89,50,0.06); border-radius: 12px; border: 1px solid rgba(14,89,50,0.1); }
    .contact-pill .icon { width: 44px; height: 44px; border-radius: 50%; background: var(--primary); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .satisfy-imgs { display: flex; align-items: center; }
    .satisfy-img { width: 38px; height: 38px; border-radius: 50%; overflow: hidden; border: 2px solid white; margin-left: -8px; }
    .satisfy-img:first-child { margin-left: 0; }
    .satisfy-img img { width: 100%; height: 100%; object-fit: cover; }
    .satisfy-img.plus { background: var(--accent); display: flex; align-items: center; justify-content: center; }
    @media (max-width: 1024px) {
      .cosa-nav-links { display: none; }
      .grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
      .grid-3 { grid-template-columns: repeat(2, 1fr) !important; }
    }
    @media (max-width: 768px) {
      .grid-2 { grid-template-columns: 1fr !important; }
      .grid-3 { grid-template-columns: 1fr !important; }
      .grid-4 { grid-template-columns: 1fr !important; }
      .parallax-bg { background-attachment: scroll; }
      .section-h2 { font-size: 26px; }
      .cosa-topbar .topbar-right { display: none; }
    }
  `;

  return (
    <div className="cosa-page">
      <style>{css}</style>

      {/* TOPBAR */}
      <div className="cosa-topbar">
        <div className="cosa-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ margin: 0, fontSize: 14, color: 'white', fontWeight: 500 }}>
            Votre Sante, Notre Mission —{' '}
            <a href="#contact" style={{ color: 'white', fontWeight: 700, textDecoration: 'underline' }}>Prendre Rendez-vous</a>
          </p>
          <div className="topbar-right" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div style={{ display: 'flex', gap: 14 }}>
              {['Aide', 'Support', 'Contact'].map((item) =>
              <a key={item} href="#contact" style={{ color: 'white', fontSize: 13, fontWeight: 500 }}>{item}</a>
              )}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              {['fa-brands fa-facebook-f', 'fa-brands fa-linkedin-in', 'fa-brands fa-instagram', 'fa-brands fa-whatsapp'].map((icon, i) =>
              <a key={i} href="#" style={{ color: 'white', fontSize: 14 }}><i className={icon}></i></a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* HEADER */}
      <div id="accueil">
        <div className={`cosa-header${scrolled ? ' sticky' : ''}`}>
          <div className="cosa-container">
            <nav className="cosa-nav">
              <a href="#accueil"><CosaLogo dark /></a>
              <div className="cosa-nav-links">
                {navItems.map((item) =>
                <div key={item.label} className="cosa-nav-item"
                onMouseEnter={() => item.children && setActiveDropdown(item.label)}
                onMouseLeave={() => setActiveDropdown(null)}>
                  
                    <a href={item.href} className="cosa-nav-link">
                      {item.label}
                      {item.children && <i className="fa-solid fa-chevron-down" style={{ fontSize: 9, opacity: 0.6 }}></i>}
                    </a>
                    {item.children && activeDropdown === item.label &&
                  <div className="cosa-dropdown">
                        {item.children.map((child) =>
                    <a key={child.label} href={child.href}>{child.label}</a>
                    )}
                      </div>
                  }
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <a href="#contact" className="btn-cosa" style={{ fontSize: 14, padding: '13px 22px' }}>Prendre Rendez-vous</a>
                <button onClick={() => setMobileMenuOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, display: 'flex', flexDirection: 'column', gap: 5 }} aria-label="Menu">
                  <span style={{ width: 24, height: 2, background: '#1a1a1a', display: 'block' }}></span>
                  <span style={{ width: 24, height: 2, background: '#1a1a1a', display: 'block' }}></span>
                  <span style={{ width: 24, height: 2, background: '#1a1a1a', display: 'block' }}></span>
                </button>
              </div>
            </nav>
          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu${mobileMenuOpen ? ' open' : ''}`}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
          <CosaLogo dark />
          <button onClick={() => setMobileMenuOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#1a1a1a' }}>x</button>
        </div>
        {navItems.map((item) =>
        <a key={item.label} href={item.href} className="mobile-link" onClick={() => setMobileMenuOpen(false)}>{item.label}</a>
        )}
        <div style={{ marginTop: 28 }}>
          <a href="#contact" className="btn-cosa" onClick={() => setMobileMenuOpen(false)}>Prendre Rendez-vous</a>
        </div>
      </div>

      {/* HERO SLIDER */}
      <HeroSlider />

      {/* ABOUT */}
      <div id="apropos" style={{ padding: '100px 0', background: '#F0F7F3' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 60, alignItems: 'center' }} className="grid-2">
            <AnimatedSection>
              <div style={{ position: 'relative', height: 520 }}>
                <div style={{ position: 'absolute', top: 0, left: 0, width: '65%', height: '70%', borderRadius: 16, overflow: 'hidden', boxShadow: '0 20px 60px rgba(14,89,50,0.2)' }} className="image-anime">
                  <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80" alt="Medecin africain en consultation avec un patient dans une clinique moderne COSA Abidjan" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ position: 'absolute', bottom: 0, right: 0, width: '55%', height: '55%', borderRadius: 16, overflow: 'hidden', boxShadow: '0 20px 60px rgba(14,89,50,0.2)', border: '4px solid white' }} className="image-anime">
                  <img src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=600&q=80" alt="Equipe medicale africaine souriante dans les locaux modernes de COSA Ananeraie Abidjan" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ position: 'absolute', bottom: '30%', left: '8%', background: '#0e5932', borderRadius: 14, padding: '14px 18px', boxShadow: '0 8px 30px rgba(14,89,50,0.3)' }}>
                  <div style={{ fontSize: 26, fontWeight: 800, color: '#fbaf45' }}>70+</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>Ans d expertise</div>
                </div>
              </div>
            </AnimatedSection>
            <div>
              <AnimatedSection><span className="section-badge">A Propos de COSA</span></AnimatedSection>
              <AnimatedSection delay={0.1}>
                <h2 className="section-h2">Soins medicaux d excellence en Cote d Ivoire</h2>
                <p className="section-p" style={{ marginBottom: 22 }}>COSA, Compagnie de Sante Africaine, est un centre medical innovant et de haute qualite, concu pour repondre aux besoins croissants de services de sante prives en Cote d Ivoire et en Afrique.</p>
              </AnimatedSection>
              <AnimatedSection delay={0.2}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14, margin: '22px 0' }}>
                  {[
                  { icon: 'fa-solid fa-bullseye', title: 'Notre Mission', text: 'Fournir des soins de sante superieurs, accessibles, repondant aux plus hauts standards internationaux.' },
                  { icon: 'fa-solid fa-eye', title: 'Notre Vision', text: 'Devenir le leader inconteste des soins de sante en Cote d Ivoire, alliant excellence et accessibilite.' }].
                  map((item) =>
                  <div key={item.title} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                      <div style={{ width: 46, height: 46, borderRadius: 12, background: 'rgba(14,89,50,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <i className={item.icon} style={{ color: '#0e5932', fontSize: 17 }}></i>
                      </div>
                      <div>
                        <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 3 }}>{item.title}</h3>
                        <p style={{ fontSize: 14, lineHeight: '1.6em' }}>{item.text}</p>
                      </div>
                    </div>
                  )}
                </div>
              </AnimatedSection>
              <AnimatedSection delay={0.3}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 22, flexWrap: 'wrap' }}>
                  <a href="#histoire" className="btn-cosa">En Savoir Plus</a>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 46, height: 46, borderRadius: '50%', background: '#0e5932', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa-solid fa-phone" style={{ color: 'white', fontSize: 15 }}></i>
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: '#7D7D75' }}>Appelez-nous</div>
                      <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a' }}>+225 XX XX XX XX</div>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </div>

      {/* HISTORY TIMELINE */}
      <div id="histoire" className="bg-white-card" style={{ padding: '80px 0' }}>
        <div className="cosa-container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <AnimatedSection>
              <span className="section-badge">Notre Histoire</span>
              <h2 className="section-h2" style={{ textAlign: 'center' }}>70 ans d expertise medicale en Afrique</h2>
            </AnimatedSection>
          </div>
          <div style={{ maxWidth: 680, margin: '0 auto' }}>
            {[
            { year: '1954', title: 'Fondation du Laboratoire Dr. Pierre MONTAGNIER', desc: 'Premier etablissement prive de biologie medicale en Cote d Ivoire, fonde par le Docteur Pierre MONTAGNIER, pharmacien biologiste.' },
            { year: '2011', title: 'Creation de CONCEPT LABO', desc: 'Societe Anonyme Ivoirienne de Conception de Laboratoires d Analyses Medicales, qui acquiert le Laboratoire Dr. Pierre MONTAGNIER.' },
            { year: '2023', title: 'Arrivee du Groupe Cofina', desc: 'Arrivee de nouveaux actionnaires dont le Groupe Cofina, acteur majeur de l innovation et de la mesofinance, pour accelerer l innovation.' },
            { year: '2025', title: 'Lancement de la vision COSA', desc: 'Franchise medicale panafricaine offrant services medicaux et biomedicaux de pointe a travers toute l Afrique.' }].
            map((item, i) =>
            <AnimatedSection key={item.year} delay={i * 0.1}>
                <div className="timeline-item">
                  <div className="timeline-dot">{item.year.slice(2)}</div>
                  <div style={{ paddingTop: 4 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#fbaf45', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 3 }}>{item.year}</div>
                    <h3 style={{ fontSize: 17, fontWeight: 700, color: '#1a1a1a', marginBottom: 6 }}>{item.title}</h3>
                    <p style={{ fontSize: 14, lineHeight: '1.6em' }}>{item.desc}</p>
                  </div>
                </div>
              </AnimatedSection>
            )}
          </div>
        </div>
      </div>

      {/* SERVICES */}
      <div id="services" style={{ padding: '100px 0', background: '#F0F7F3' }}>
        <div className="cosa-container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <AnimatedSection>
              <span className="section-badge">Nos Services</span>
              <h2 className="section-h2" style={{ textAlign: 'center' }}>Services medicaux complets pour toute la famille</h2>
            </AnimatedSection>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 40, alignItems: 'start' }} className="grid-2">
            <div>
              {services.map((service, i) =>
              <AnimatedSection key={service.title} delay={i * 0.07}>
                  <div className="service-item">
                    <div className="icon-box-sm">
                      <i className={service.icon} style={{ color: '#0e5932', fontSize: 21 }}></i>
                    </div>
                    <div style={{ flex: 1 }}>
                      <h2 style={{ fontSize: 17, fontWeight: 700, color: '#1a1a1a', marginBottom: 5 }}>{service.title}</h2>
                      <p style={{ fontSize: 14, lineHeight: '1.6em' }}>{service.description}</p>
                      {service.slug &&
                    <Link href={`/services/${service.slug}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 10, fontSize: 13, fontWeight: 600, color: '#0e5932', transition: 'color 0.3s' }}>
                          En savoir plus <i className="fa-solid fa-arrow-right" style={{ fontSize: 11 }}></i>
                        </Link>
                    }
                    </div>
                  </div>
                </AnimatedSection>
              )}
            </div>
            <AnimatedSection delay={0.2}>
              <div style={{ background: '#0e5932', borderRadius: 16, overflow: 'hidden', boxShadow: '0 20px 60px rgba(14,89,50,0.3)' }}>
                <div style={{ height: 220, overflow: 'hidden' }} className="image-anime">
                  <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&q=80" alt="Infirmiere africaine en blouse blanche accueillant chaleureusement un patient au centre COSA Abidjan" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: 26 }}>
                  <h3 style={{ fontSize: 19, fontWeight: 700, color: 'white', marginBottom: 14, lineHeight: '1.3em' }}>Des soins d excellence pour une sante optimale</h3>
                  <a href="#contact" className="btn-cosa sm">Voir Tous les Services</a>
                </div>
              </div>
            </AnimatedSection>
          </div>
          <AnimatedSection delay={0.4}>
            <div className="footer-text-bar">
              <p><span>Gratuit</span>Explorez nos services medicaux et commencez votre parcours vers une meilleure sante. <a href="#contact">Prendre Rendez-vous</a></p>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* WHY CHOOSE US */}
      <div id="mission" className="bg-white-card" style={{ padding: '100px 0' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 60, alignItems: 'center' }} className="grid-2">
            <div>
              <AnimatedSection><span className="section-badge">Pourquoi Choisir COSA</span></AnimatedSection>
              <AnimatedSection delay={0.1}>
                <h2 className="section-h2">Des resultats fiables en medecine africaine</h2>
                <p className="section-p" style={{ marginBottom: 20 }}>Nous nous engageons a fournir des soins surs, efficaces et fiables grace a des equipements medicaux de pointe et une equipe de professionnels qualifies.</p>
              </AnimatedSection>
              <AnimatedSection delay={0.2}>
                <div className="why-list">
                  <ul>
                    {['Equipements medicaux de pointe', 'Medecins specialistes qualifies', 'Telemedecine innovante', 'Reseau panafricain', 'Standards internationaux', 'Cadre moderne et accueillant'].map((item) =>
                    <li key={item}>{item}</li>
                    )}
                  </ul>
                </div>
                <div className="why-quote">
                  Nous offrons des soins d excellence, des technologies avancees et des solutions personnalisees pour aider chaque patient a atteindre une sante optimale avec confiance.
                </div>
              </AnimatedSection>
              <AnimatedSection delay={0.3}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap' }}>
                  <a href="#contact" className="btn-cosa">Consultation Gratuite</a>
                  <div className="contact-pill">
                    <div className="icon"><i className="fa-solid fa-headset" style={{ color: 'white', fontSize: 17 }}></i></div>
                    <div>
                      <p style={{ margin: 0, fontSize: 11, color: '#7D7D75' }}>Numero de telephone</p>
                      <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1a1a1a' }}>+225 XX XX XX XX</h3>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            </div>
            <AnimatedSection>
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                  <div style={{ height: 230, borderRadius: 14, overflow: 'hidden' }} className="image-anime">
                    <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png" alt="Medecin africain en blouse blanche examinant un patient avec un stethoscope dans une clinique moderne" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div style={{ height: 230, borderRadius: 14, overflow: 'hidden', marginTop: 30 }} className="image-anime">
                    <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png" alt="Infirmiere africaine prenant soin d un patient dans une salle de soins moderne et equipee" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                  {stats.slice(0, 2).map((stat) =>
                  <div key={stat.label} className="counter-box"><StatCounter {...stat} /></div>
                  )}
                  <div style={{ gridColumn: '1 / -1', height: 190, borderRadius: 14, overflow: 'hidden' }} className="image-anime">
                    <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png" alt="Equipe medicale africaine diverse en tenue professionnelle dans un couloir de clinique moderne COSA" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>

      {/* VALUES */}
      <div id="valeurs" className="parallax-bg" style={{ padding: '100px 0', backgroundImage: "url('/assets/images/clinic_values_team.png')", position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(14,89,50,0.92)' }}></div>
        <div className="cosa-container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <AnimatedSection>
              <span className="section-badge white">Nos Valeurs</span>
              <h2 className="section-h2 white" style={{ textAlign: 'center' }}>Les valeurs fondamentales de COSA</h2>
            </AnimatedSection>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 22 }} className="grid-3">
            {values.map((value, i) =>
            <AnimatedSection key={value.title} delay={i * 0.1}>
                <div className="value-card">
                  <div className="icon-box-lg">
                    <i className={value.icon} style={{ color: '#0e5932', fontSize: 23 }}></i>
                  </div>
                  <h3 style={{ fontSize: 17, fontWeight: 700, color: '#1a1a1a', marginBottom: 9 }}>{value.title}</h3>
                  <p style={{ fontSize: 14, lineHeight: '1.6em' }}>{value.description}</p>
                </div>
              </AnimatedSection>
            )}
          </div>
        </div>
      </div>

      {/* SPECIALTIES */}
      <div style={{ padding: '100px 0', background: '#F0F7F3' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 40, alignItems: 'end', marginBottom: 48 }} className="grid-2">
            <AnimatedSection>
              <span className="section-badge">Specialites Medicales</span>
              <h2 className="section-h2">Transformer la sante avec expertise et precision</h2>
            </AnimatedSection>
            <AnimatedSection delay={0.1}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', gap: 14, alignItems: 'flex-end' }}>
                <p className="section-p" style={{ textAlign: 'right' }}>Nous sommes fiers de proposer des traitements medicaux personnalises qui creent des transformations visibles et durables.</p>
                <a href="#services" className="btn-cosa">Voir Toutes les Specialites</a>
              </div>
            </AnimatedSection>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 22 }} className="grid-3">
            {[
            { image: "https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png", alt: 'Pediatre africain examinant un enfant avec ses parents dans une salle de consultation moderne et accueillante', tag: 'Pediatrie', title: 'Soins pediatriques specialises pour les enfants' },
            { image: "https://img.rocket.new/generatedImages/rocket_gen_img_1986f3dc5-1778479805666.png", alt: 'Gynecologue africaine en consultation prenatale avec une patiente dans une salle moderne equipee', tag: 'Gynecologie', title: 'Suivi gynecologique et obstetrical complet' },
            { image: "https://img.rocket.new/generatedImages/rocket_gen_img_1648c4252-1772108848062.png", alt: 'Technicien de laboratoire africain analysant des echantillons biologiques avec equipements modernes de precision', tag: 'Analyses Biomedicales', title: 'Analyses biomedicales de haute precision' }].
            map((item, i) =>
            <AnimatedSection key={item.tag} delay={i * 0.15}>
                <div className="case-item">
                  <div className="case-item-img"><img src={item.image} alt={item.alt} /></div>
                  <div className="case-item-overlay">
                    <div className="case-item-tag">{item.tag}</div>
                    <div className="case-item-title">{item.title}</div>
                  </div>
                </div>
              </AnimatedSection>
            )}
          </div>
          <AnimatedSection delay={0.4}>
            <div className="footer-text-bar">
              <div className="satisfy-imgs">
                <div className="satisfy-img"><img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=80&q=80" alt="Patient satisfait COSA" /></div>
                <div className="satisfy-img"><img src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=80&q=80" alt="Medecin COSA" /></div>
                <div className="satisfy-img plus"><i className="fa-solid fa-phone" style={{ color: 'white', fontSize: 11 }}></i></div>
              </div>
              <p>Ensemble, construisons une meilleure sante pour l Afrique. <a href="#contact">Prendre Rendez-vous</a></p>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* INFRASTRUCTURE */}
      <div className="bg-white-card" style={{ padding: '100px 0' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 60, alignItems: 'center' }} className="grid-2">
            <AnimatedSection>
              <div style={{ position: 'relative' }}>
                <div style={{ borderRadius: 20, overflow: 'hidden', height: 500 }} className="image-anime">
                  <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&q=80" alt="Salle de consultation moderne du centre medical COSA avec equipements medicaux de pointe et design soigne" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ position: 'absolute', bottom: 22, left: 22, background: '#0e5932', borderRadius: 14, padding: '18px 22px', maxWidth: 210 }}>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginBottom: 3 }}>Plateau technique</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: 'white', lineHeight: '1.3em' }}>Equipements medicaux de pointe</div>
                </div>
              </div>
            </AnimatedSection>
            <div>
              <AnimatedSection><span className="section-badge">Notre Infrastructure</span></AnimatedSection>
              <AnimatedSection delay={0.1}>
                <h2 className="section-h2">Traitements specialises avances pour votre sante</h2>
              </AnimatedSection>
              <AnimatedSection delay={0.15}>
                {specialties.map((item) =>
                <div key={item.title} className="special-item">
                    <div className="special-item-img"><img src={item.image} alt={item.alt} /></div>
                    <div>
                      <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 5 }}>{item.title}</h3>
                      <p style={{ fontSize: 13, lineHeight: '1.5em' }}>{item.description}</p>
                    </div>
                  </div>
                )}
              </AnimatedSection>
            </div>
          </div>
        </div>
      </div>

      {/* FRANCHISE */}
      <div id="franchise" style={{ padding: '100px 0', background: '#F0F7F3' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 60, alignItems: 'center' }} className="grid-2">
            <div>
              <AnimatedSection><span className="section-badge">Notre Franchise</span></AnimatedSection>
              <AnimatedSection delay={0.1}>
                <h2 className="section-h2">Un reseau medical panafricain en franchise</h2>
                <p className="section-p" style={{ marginBottom: 28 }}>COSA opere via un modele de franchise medicale permettant de deployer un reseau de centres medicaux d excellence a travers l Afrique.</p>
              </AnimatedSection>
              <AnimatedSection delay={0.15}>
                <div style={{ margin: '0 0 28px' }}>
                  {[
                  { num: '01', title: 'Assistance technique complete', desc: 'Processus standardises de relation client et de gestion medicale.' },
                  { num: '02', title: 'Formation et ressources humaines', desc: 'Formation continue du personnel pour maintenir un haut niveau de competence.' },
                  { num: '03', title: 'Controle qualite et certification', desc: 'Audits reguliers, gestion des risques et certification internationale.' },
                  { num: '04', title: 'Segments cibles', desc: 'Classe moyenne, entreprises, collectivites, cooperatives et compagnies d assurances.' }].
                  map((step) =>
                  <div key={step.num} className="franchise-step">
                      <div className="franchise-num">{step.num}</div>
                      <div>
                        <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 3 }}>{step.title}</h3>
                        <p style={{ fontSize: 13, lineHeight: '1.5em' }}>{step.desc}</p>
                      </div>
                    </div>
                  )}
                </div>
              </AnimatedSection>
              <AnimatedSection delay={0.2}><a href="#contact" className="btn-cosa">Devenir Franchise</a></AnimatedSection>
            </div>
            <AnimatedSection delay={0.1}>
              <div style={{ position: 'relative', height: 500 }}>
                <div style={{ borderRadius: 20, overflow: 'hidden', height: '100%' }} className="image-anime">
                  <img src="https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=600&q=80" alt="Facade moderne du centre medical COSA avec signalisation verte et doree en Cote d Ivoire Abidjan" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ position: 'absolute', top: 22, right: 22, background: '#fbaf45', borderRadius: 14, padding: '14px 18px', textAlign: 'center' }}>
                  <div style={{ fontSize: 26, fontWeight: 800, color: 'white' }}>1</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>Reseau panafricain</div>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>

      {/* STATS */}
      <div style={{ padding: '80px 0', background: '#0e5932' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 30 }} className="grid-4">
            {stats.map((stat, i) =>
            <AnimatedSection key={stat.label} delay={i * 0.1}>
                <StatCounter {...stat} />
              </AnimatedSection>
            )}
          </div>
        </div>
      </div>

      {/* APPOINTMENT PARALLAX */}
      <div
        id="contact"
        className="parallax-bg"
        style={{ backgroundImage: "url('/assets/images/clinic_parallax_appointment.png')", position: 'relative' }}>
        
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(14,89,50,0.88)' }}></div>
        <div className="cosa-container" style={{ padding: '100px 15px', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 60, alignItems: 'start' }} className="grid-2">
            <div>
              <AnimatedSection>
                <span className="section-badge gold">Prendre Rendez-vous</span>
                <h2 className="section-h2 white">Prenez rendez-vous avec nos experts medicaux</h2>
                <p className="section-p white" style={{ marginBottom: 0 }}>Planifiez votre consultation avec nos specialistes medicaux et beneficiez de soins personnalises adaptes a vos besoins.</p>
              </AnimatedSection>
              <AnimatedSection delay={0.2}>
                <div className="appt-hours">
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                    <i className="fa-regular fa-clock" style={{ color: '#fbaf45', fontSize: 18 }}></i>
                    <h3 style={{ color: 'white', fontSize: 15, fontWeight: 700, margin: 0 }}>Horaires d ouverture :</h3>
                  </div>
                  <ul>
                    <li><span>Lundi - Vendredi :</span> 8h00 - 18h00</li>
                    <li><span>Samedi :</span> 8h00 - 14h00</li>
                    <li><span>Dimanche :</span> Ferme</li>
                  </ul>
                </div>
              </AnimatedSection>
            </div>
            <AnimatedSection delay={0.1}>
              <div style={{ background: 'white', borderRadius: 20, padding: 36 }}>
                <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1a1a1a', marginBottom: 26 }}>Prendre un Rendez-vous</h2>
                <form onSubmit={handleFormSubmit}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                    <div><label className="form-label">Nom *</label><input type="text" name="nom" className="form-field" placeholder="Votre nom" value={formData.nom} onChange={handleFormChange} required /></div>
                    <div><label className="form-label">Prenom *</label><input type="text" name="prenom" className="form-field" placeholder="Votre prenom" value={formData.prenom} onChange={handleFormChange} required /></div>
                    <div><label className="form-label">Telephone *</label><input type="tel" name="telephone" className="form-field" placeholder="+225 XX XX XX XX" value={formData.telephone} onChange={handleFormChange} required /></div>
                    <div><label className="form-label">Email *</label><input type="email" name="email" className="form-field" placeholder="votre@email.com" value={formData.email} onChange={handleFormChange} required /></div>
                    <div>
                      <label className="form-label">Service souhaite</label>
                      <select name="service" className="form-field" value={formData.service} onChange={handleFormChange}>
                        <option value="">Choisir un service</option>
                        {services.map((s) => <option key={s.title} value={s.title}>{s.title}</option>)}
                      </select>
                    </div>
                    <div><label className="form-label">Date souhaitee</label><input type="date" name="date" className="form-field" value={formData.date} onChange={handleFormChange} /></div>
                  </div>
                  <div style={{ marginBottom: 22 }}>
                    <label className="form-label">Message</label>
                    <textarea name="message" className="form-field" rows={4} placeholder="Decrivez votre demande..." value={formData.message} onChange={handleFormChange} style={{ resize: 'vertical' }}></textarea>
                  </div>
                  <button type="submit" className="btn-cosa" style={{ width: '100%', textAlign: 'center' }}>Confirmer le Rendez-vous</button>
                </form>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div style={{ padding: '100px 0', background: '#F0F7F3' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 60, alignItems: 'start' }} className="grid-2">
            <AnimatedSection>
              <div style={{ position: 'relative' }}>
                <div style={{ borderRadius: 20, overflow: 'hidden', height: 420 }} className="image-anime">
                  <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png" alt="Medecin africain en consultation avec un patient repondant a ses questions medicales dans un cabinet moderne" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div className="faq-cta">
                  <h2 style={{ fontSize: 17, fontWeight: 700, color: 'white', marginBottom: 14 }}>Contactez-nous pour plus d informations :</h2>
                  <ul>
                    <li><a href="tel:+22500000000"><i className="fa-solid fa-phone" style={{ color: '#fbaf45' }}></i> +225 XX XX XX XX</a></li>
                    <li><a href="mailto:contact@cosa-sante.ci"><i className="fa-solid fa-envelope" style={{ color: '#fbaf45' }}></i> contact@cosa-sante.ci</a></li>
                    <li><a href="#"><i className="fa-brands fa-whatsapp" style={{ color: '#fbaf45' }}></i> WhatsApp COSA</a></li>
                  </ul>
                </div>
              </div>
            </AnimatedSection>
            <div>
              <AnimatedSection>
                <span className="section-badge">Questions Frequentes</span>
                <h2 className="section-h2">Tout ce que vous devez savoir sur COSA</h2>
                <p className="section-p" style={{ marginBottom: 24 }}>Trouvez des reponses claires a vos questions les plus courantes sur nos services medicaux et notre fonctionnement.</p>
              </AnimatedSection>
              <AnimatedSection delay={0.1}>
                {faqs.map((faq, i) =>
                <div key={i} className={`accordion-item${openFaq === i ? ' open' : ''}`}>
                    <button className={`accordion-btn${openFaq === i ? ' open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                      {faq.question}
                      <i className={`fa-solid ${openFaq === i ? 'fa-minus' : 'fa-plus'}`} style={{ color: '#fbaf45', fontSize: 13, flexShrink: 0 }}></i>
                    </button>
                    {openFaq === i && <div className="accordion-body"><p style={{ margin: 0 }}>{faq.answer}</p></div>}
                  </div>
                )}
              </AnimatedSection>
            </div>
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="bg-white-card" style={{ padding: '100px 0' }}>
        <div className="cosa-container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <AnimatedSection>
              <span className="section-badge">Temoignages Patients</span>
              <h2 className="section-h2" style={{ textAlign: 'center' }}>Avis et temoignages de nos patients</h2>
              <p className="section-p" style={{ margin: '0 auto' }}>Decouvrez les experiences de nos patients qui ont beneficie de soins medicaux d excellence chez COSA.</p>
            </AnimatedSection>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 22 }} className="grid-2">
            {[testimonials[activeTestimonial], testimonials[(activeTestimonial + 1) % testimonials.length]].map((t, i) =>
            <AnimatedSection key={`${activeTestimonial}-${i}`} delay={i * 0.1}>
                <div className="testimonial-card">
                  <div>
                    <div style={{ display: 'flex', gap: 3, marginBottom: 14 }}>
                      {[1, 2, 3, 4, 5].map((s) => <i key={s} className="fa-solid fa-star" style={{ color: '#fbaf45', fontSize: 13 }}></i>)}
                    </div>
                    <p style={{ fontSize: 15, lineHeight: '1.7em', color: '#555', fontStyle: 'italic', marginBottom: 14 }}>{t.quote}</p>
                    <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', margin: 0 }}>- {t.author}</h3>
                    <p style={{ fontSize: 12, color: '#7D7D75', margin: '3px 0 0' }}>{t.role}</p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14, paddingTop: 18, borderTop: '1px solid rgba(14,89,50,0.08)' }}>
                    <div>
                      <div style={{ fontSize: 30, fontWeight: 800, color: '#0e5932' }}>{t.satisfaction}%</div>
                      <div style={{ fontSize: 12, color: '#7D7D75' }}>Taux de satisfaction</div>
                    </div>
                    <div style={{ flex: 1, height: 5, background: 'rgba(14,89,50,0.1)', borderRadius: 3, overflow: 'hidden' }}>
                      <div style={{ width: `${t.satisfaction}%`, height: '100%', background: 'linear-gradient(90deg, #0e5932, #fbaf45)', borderRadius: 3, transition: 'width 1s ease' }}></div>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            )}
          </div>
          <div className="swiper-dots">
            {testimonials.map((_, i) =>
            <button key={i} className={`swiper-dot${i === activeTestimonial ? ' active' : ''}`} onClick={() => setActiveTestimonial(i)} aria-label={`Temoignage ${i + 1}`}></button>
            )}
          </div>
          <AnimatedSection delay={0.3}>
            <div className="footer-text-bar">
              <p><span>Gratuit</span>Rejoignez des milliers de patients satisfaits. <a href="#contact">Prendre Rendez-vous</a></p>
              <ul className="border-list">
                <li>Approuve par <b>+5 000</b> patients</li>
                <li><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i> <b>4.9/5</b></li>
              </ul>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* PARTNERS */}
      <div id="partenaires" style={{ padding: '100px 0', background: '#F0F7F3' }}>
        <div className="cosa-container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <AnimatedSection>
              <span className="section-badge">Nos Partenaires</span>
              <h2 className="section-h2" style={{ textAlign: 'center' }}>Un reseau de partenaires de confiance</h2>
              <p className="section-p" style={{ margin: '0 auto' }}>COSA collabore avec les plus grandes entreprises et institutions pour offrir des soins medicaux a leurs employes et clients.</p>
            </AnimatedSection>
          </div>
          <AnimatedSection delay={0.1}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
              {partners.map((partner) =>
              <div key={partner} className="partner-pill">
                  <i className="fa-solid fa-circle" style={{ color: '#fbaf45', fontSize: 7, marginRight: 7 }}></i>
                  {partner}
                </div>
              )}
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* BLOG */}
      <div className="bg-white-card" style={{ padding: '100px 0' }}>
        <div className="cosa-container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 40, alignItems: 'end', marginBottom: 48 }} className="grid-2">
            <AnimatedSection>
              <span className="section-badge">Actualites & Conseils</span>
              <h2 className="section-h2">Conseils sante, actualites et mises a jour medicales</h2>
            </AnimatedSection>
            <AnimatedSection delay={0.1}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', gap: 14, alignItems: 'flex-end' }}>
                <p className="section-p" style={{ textAlign: 'right' }}>Restez informe avec nos conseils medicaux professionnels et les dernieres actualites en matiere de sante en Afrique.</p>
                <a href="#" className="btn-cosa">Voir Tous les Articles</a>
              </div>
            </AnimatedSection>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 22 }} className="grid-3">
            {blogPosts.map((post, i) =>
            <AnimatedSection key={post.title} delay={i * 0.15}>
                <div className="post-card">
                  <div className="post-img">
                    <img src={post.image} alt={post.alt} />
                    <div className="post-tag">{post.tag}</div>
                  </div>
                  <div className="post-body">
                    <div className="post-title">{post.title}</div>
                    <a href="#" className="readmore">Lire la Suite</a>
                  </div>
                </div>
              </AnimatedSection>
            )}
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer style={{ background: '#0e5932', padding: '80px 0 0' }}>
        <div className="cosa-container">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 38, borderBottom: '1px solid rgba(255,255,255,0.1)', flexWrap: 'wrap', gap: 18 }}>
            <CosaLogo />
            <div style={{ display: 'flex', gap: 22, flexWrap: 'wrap' }}>
              <a href="tel:+22500000000" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'white', fontSize: 14 }}>
                <i className="fa-solid fa-phone" style={{ color: '#fbaf45' }}></i> +225 XX XX XX XX
              </a>
              <a href="mailto:contact@cosa-sante.ci" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'white', fontSize: 14 }}>
                <i className="fa-solid fa-envelope" style={{ color: '#fbaf45' }}></i> contact@cosa-sante.ci
              </a>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1.4fr', gap: 38, padding: '56px 0 38px' }} className="grid-4">
            <div>
              <h2 style={{ fontSize: 17, fontWeight: 700, color: 'white', marginBottom: 14 }}>A Propos de COSA</h2>
              <p style={{ fontSize: 14, lineHeight: '1.7em', color: 'rgba(255,255,255,0.65)' }}>COSA - Compagnie de Sante Africaine. L excellence medicale accessible a tous, a travers l Afrique.</p>
              <div style={{ marginTop: 14 }}>
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 3 }}>COSA Ananeraie</p>
                <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)', margin: 0 }}>Abidjan, Cote d Ivoire</p>
              </div>
            </div>
            <div>
              <h2 style={{ fontSize: 17, fontWeight: 700, color: 'white', marginBottom: 14 }}>Liens Rapides</h2>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
                {[['Accueil', '#accueil'], ['A Propos', '#apropos'], ['Services', '#services'], ['Partenaires', '#partenaires'], ['Contact', '#contact']].map(([label, href]) =>
                <li key={label}><a href={href} className="footer-link"><i className="fa-solid fa-chevron-right" style={{ fontSize: 9, color: '#fbaf45' }}></i>{label}</a></li>
                )}
              </ul>
            </div>
            <div>
              <h2 style={{ fontSize: 17, fontWeight: 700, color: 'white', marginBottom: 14 }}>Nos Services</h2>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
                {services.slice(0, 5).map((s) =>
                <li key={s.title}><a href="#services" className="footer-link"><i className="fa-solid fa-chevron-right" style={{ fontSize: 9, color: '#fbaf45' }}></i>{s.title}</a></li>
                )}
              </ul>
            </div>
            <div>
              <h2 style={{ fontSize: 17, fontWeight: 700, color: 'white', marginBottom: 14 }}>Newsletter Sante</h2>
              <form onSubmit={(e) => e.preventDefault()} style={{ marginBottom: 22, position: 'relative' }}>
                <input type="email" className="footer-nl-input" placeholder="Votre adresse e-mail *" required />
                <button type="submit" style={{ position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)', background: '#fbaf45', border: 'none', borderRadius: '50%', width: 34, height: 34, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-regular fa-paper-plane" style={{ color: 'white', fontSize: 13 }}></i>
                </button>
              </form>
              <h3 style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.7)', marginBottom: 10 }}>Suivez-nous :</h3>
              <div style={{ display: 'flex', gap: 8 }}>
                {['fa-brands fa-facebook-f', 'fa-brands fa-linkedin-in', 'fa-brands fa-instagram', 'fa-brands fa-whatsapp'].map((icon, i) =>
                <a key={i} href="#" className="social-btn"><i className={icon}></i></a>
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', padding: '18px 0' }}>
          <div className="cosa-container" style={{ textAlign: 'center' }}>
            <p style={{ margin: 0, fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>
              2025 COSA - Compagnie de Sante Africaine. Tous droits reserves.
            </p>
          </div>
        </div>
      </footer>
    </div>);

}